<template>
  <div>
    <v-container class="col-11 ml-0 mt-4 pl-0 pb-7 pt-0">
      <v-col class="pb-4 pt-0 pl-0">
        <p class="mt-0 mb-0 title font-weight-bold">개별 상품 등록하기</p>
        <p class="mt-2 mb-0 subtitle-2 font-weight-medium">
          정품인증서비스에서 관리하실 상품의 정보를 입력하고 저장해주세요.
        </p>
      </v-col>

      <div style="width:1100px;">
        <v-row>
          <v-col class="col-2">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              상품명
            </p>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              hide-details="true"
              v-model="productName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-2">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              상품코드
            </p>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              hide-details="true"
              v-model="productCode"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-2">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              판매가
            </p>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              hide-details="true"
              v-model="sellPrice"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-2">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              공급사명
            </p>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              hide-details="true"
              v-model="supplyName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-2">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              제조사명
            </p>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              hide-details="true"
              v-model="manufacturerName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-2">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              브랜드명
            </p>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              hide-details="true"
              v-model="brandName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-2">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              상품이미지
            </p>
          </v-col>
          <v-col class="pb-0 pt-1 pl-1">
            <v-file-input
              chips
              label="클릭하여 이미지를 업로드해주세요."
              class="pt-1 pl-1"
              accept="image/*"
              hide-details="true"
              v-model="file"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row class="mb-6" style="height:40px;">
          <v-col class="col-2 pb-0 pt-3">
            <p
              class="mb-0 body-1 black--text"
              style="height: 40px ;display: table-cell; vertical-align: middle;"
            >
              옵션
            </p>
          </v-col>
          <v-col class="col-3 pb-0 pt-3">
            <v-select
              v-model="optionItemSelect"
              :items="optionSelectItem"
              outlined
              dense
              single-line
              item-text="text"
              item-value="value"
              @change="optionStateChange()"
              hide-details="true"
            ></v-select>
          </v-col>
          <v-col class="col-5 pb-0 pt-3">
            <v-text-field
              outlined
              dense
              hide-details="true"
              v-model="optionName"
              :disabled="optionNameDisabled"
              :label="optionLabel"
              single-line
            ></v-text-field>
          </v-col>

          <v-col class="pb-0 pt-3">
            <v-btn
              color="grey darken-4 white--text"
              large
              @click="addOption"
              :disabled="optionNameDisabled"
              style="width:100%"
              >추가</v-btn
            >
          </v-col>
        </v-row>
        <v-row
          v-for="(item, index) in addOptionList"
          v-bind:key="index"
          style="height:40px;"
          class="mt-3"
        >
          <v-col class="col-2"></v-col>
          <v-col
            class="col-3"
            style="overflow-wrap: break-word;white-space: normal;"
            >{{ item.variant_name }}</v-col
          >
          <v-col class="col-2">
            <v-text-field
              outlined
              dense
              hide-details="true"
              :value="item.variant_price"
              v-model="item.variant_price"
              placeholder="옵션 판매가 입력"
              single-line
            ></v-text-field>
          </v-col>
          <v-col class="col-3">
            <v-text-field
              outlined
              dense
              hide-details="true"
              :value="item.variant_code"
              v-model="item.variant_code"
              placeholder="품목코드 입력"
              single-line
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn
              color="grey lighten-1"
              large
              @click="deleteOption(index)"
              dense
              style="width:100%"
              >삭제</v-btn
            >
          </v-col>
        </v-row>

        <v-spacer></v-spacer>

        <v-col class="mt-7">
          <v-row class="justify-center">
            <v-btn
              color="primary"
              large
              dense
              style="width:200px;"
              class="mt-10"
              @click="productSave()"
              >저장</v-btn
            >
          </v-row>
        </v-col>
      </div>
    </v-container>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      file: [],
      productInfoEditModal: false,
      optionItemSelect: { text: "없음", value: "X" },
      optionSelectItem: [
        { text: "있음", value: "O" },
        { text: "없음", value: "X" },
      ],
      addOptionList: [],
      optionName: "",
      productName: "",
      productCode: "",
      sellPrice: "",
      supplyName: "",
      manufacturerName: "",
      brandName: "",
      optionNameDisabled: true,
      optionLabel: "",
    };
  },
  methods: {
    addOption: function() {
      if (!this.optionName) {
        this.alertShow("옵션명을 입력해주세요.");
        return false;
      }
      let addOptionArray = {
        variant_price: "",
        variant_code: "",
        variant_name: this.optionName,
      };
      this.addOptionList.push(addOptionArray);
      this.optionName = "";
    },
    deleteOption: function(v) {
      this.addOptionList.splice(v, 1);
    },
    optionStateChange: function() {
      if (this.optionItemSelect != "X") {
        this.optionNameDisabled = false;
        this.optionLabel = "옵션명 입력";
      } else {
        this.optionNameDisabled = true;
        this.optionLabel = "";
        this.addOptionList = [];
      }
    },
    productSave: async function() {
      /**
       * 데이터 체크 필요
       * 옵션 빈값 체크 필요
       */
      if (
        !this.productName ||
        !this.sellPrice ||
        !this.supplyName ||
        !this.manufacturerName ||
        !this.brandName ||
        !this.productCode
      ) {
        this.alertShow("모든 정보를 입력해 주세요.");
        return false;
      }
      let addData = {
        imageurl: "",
        product_name: this.productName,
        product_code: this.productCode,
        product_price: Number(this.sellPrice),
        vendor_name: this.supplyName,
        manufacturer_name: this.manufacturerName,
        brand_name: this.brandName,
        variant_list: this.addOptionList,
      };

      //옵션 빈값 체크
      for (let i = 0; i < this.addOptionList.length; i++) {
        if (
          !this.addOptionList[i].variant_code ||
          !this.addOptionList[i].variant_price ||
          !this.addOptionList[i].variant_name
        ) {
          this.alertShow("옵션의 정보를 확인 해주세요.");
          return false;
        }
      }

      /**
       * 이미지 등록
       */
      if (this.file.name) {
        let imageResult = await this.imageUpload();
        if (imageResult.state == "200" && imageResult.imageurl) {
          addData.imageurl = imageResult.imageurl;
        }
      }

      try {
        let result = await M.api(
          M.entry("/api/cert/partners/products"),
          addData
        );

        if (result.product_no > 0) {
          this.alertShow("저장 되었습니다.");
        } else {
          this.alertShow("저장이 되지 않았습니다.");
        }
      } catch (e) {
        this.alertShow("저장 되지 않았습니다.");
      }
    },
    imageUpload: async function() {
      if (!this.file.name) {
        this.alertShow("이미지 파일이 없습니다.");
        return false;
      }
      let formData = new FormData();
      formData.append("images", this.file, this.file.name);

      try {
        let data = await M.api(
          M.entry("/api/cert/partners/products/images/code", this.productCode),
          formData
        );
        if (data) {
          return data;
        }
      } catch (e) {
        //
        this.alertShow("이미지 등록 실패했습니다.");
      }
    },
  },
  mixins: [CommonMixin],
};
</script>
